// src/App-admin.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import FilmUpload from "./pages/admin/FilmUpload";
import FilmEdit from "./pages/admin/FilmEdit";
import FilmManagement from "./pages/admin/FilmManagement";
import PrivateRoute from "./components/admin/PrivateRoute";

function App() {
  return (
    <Router>
      <Routes>
        {/* Root path shows login OR dashboard based on auth */}
        <Route path="/" element={
          <PrivateRoute>
            <AdminDashboard />
          </PrivateRoute>
        } />
        
        {/* Login page - NO PrivateRoute wrapper */}
        <Route path="/login" element={<AdminLogin />} />
        
        {/* Admin routes with PrivateRoute */}
        <Route 
          path="/dashboard" 
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          } 
        />
        
        <Route 
          path="/films" 
          element={
            <PrivateRoute>
              <FilmManagement />
            </PrivateRoute>
          } 
        />
        
        <Route 
          path="/films/upload" 
          element={
            <PrivateRoute>
              <FilmUpload />
            </PrivateRoute>
          } 
        />
        
        <Route 
          path="/films/edit/:id" 
          element={
            <PrivateRoute>
              <FilmEdit />
            </PrivateRoute>
          } 
        />
        
        {/* Catch all - redirect to root */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;